import React from "react";
import PropTypes from "prop-types";
import { Modal, TextArea, Rating, Form } from "semantic-ui-react";
import Api from "../service/Api";
import PromiseButton from "../components/element/PromiseButton";
import ErrorWrapper from "../components/wrapper/ErrorWrapper";
import Analytics from "../service/Analytics";
import ShowOnceWrapper from "../components/wrapper/ShowOnceWrapper";

/**
 * Asks the user for a score and freeform input that is sent to our feedback slack channel
 */
class FeedbackWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: null,
      open: true,
      message: null,
    };
  }

  componentDidMount() {
    this.UNSAFE_componentWillReceiveProps(this.props);
  }

  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillReceiveProps(props) {
    if (props.hidden) {
      // set by ShowOnceWrapper when user has already seen content before
      this.doCloseModal();
    }
  }

  doCloseModal() {
    const { onClose } = this.props;

    this.setState({
      open: false,
    });

    onClose && onClose();
  }

  doSubmit() {
    return new Promise((fulfill, reject) => {
      const { message, rating } = this.state;
      const { topic, remember } = this.props;

      Api.post("/feedback/submit", {
        message,
        topic: topic || remember,
        score: rating,
      })
        .then(this.doCloseModal())
        .catch(ex => {
          const { showError } = this.props;

          showError();
          reject(ex);
        });
    });
  }

  render() {
    const { open } = this.state;
    const { shown } = this.props;

    const show = open && shown;

    if (show) {
      Analytics.writeEvent("Feedback Shown");
    }

    return (
      <Modal open={show} size="small" closeIcon="close" onClose={() => this.doCloseModal()}>
        <Modal.Header>Feedback</Modal.Header>
        <Modal.Content>
          <p>
            Your feedback is valuable to us! Please let us know what you thought about the functionality you just tried
            so that we can continue to make improvements.
          </p>

          <Form>
            <Form.Field>
              <label htmlFor="rating">Choose a Service</label>
              <select id="feedback-uploader-select">
                <option value="Dropbox">Dropbox</option>
                <option value="Google Drive">Google Drive</option>
                <option value="Other Service">Other Service</option>
              </select>
            </Form.Field>

            <Form.Field>
              <label htmlFor="rating">Rating</label>
              <Rating
                id="rating"
                maxRating={5}
                onRate={(e, data) => {
                  this.state.rating = data.rating;
                }}
              />
            </Form.Field>
            <Form.Field>
              <label htmlFor="thoughts">Your Thoughts</label>
              <TextArea
                id="thoughts"
                onChange={e => {
                  this.state.message = e.target.value;
                }}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <PromiseButton onClick={() => this.doSubmit()} content="Submit" color="green" />
        </Modal.Actions>
      </Modal>
    );
  }
}

const showWrap = ShowOnceWrapper(FeedbackWidget);
const errorWrap = ErrorWrapper(showWrap);

export default errorWrap;

FeedbackWidget.propTypes = {
  showError: PropTypes.func,
  // when true, this widget will display a modal if never seen before
  shown: PropTypes.bool,
  // a unique key to use to keep track of whether the user has seen this before
  remember: PropTypes.string,
  // the name to use when sending feedback to server (uses props.remember if not set)
  topic: PropTypes.string,
  // called when the user submits feedback or closes modal
  onClose: PropTypes.func,
  // when true, won't show dialog under any circumstance
  hidden: PropTypes.bool,
};
